// External libraries
import gql from 'graphql-tag';

// Internal modules
import { ADDRESS_METADATA_FRAGMENT } from '../fragments';

export const ADDRESS_METADATA_QUERY = gql`
  query AddressMetadataQuery(
    $countryCode: CountryCodes!
    $languageCode: CheckoutContentLanguageCode!
  ) {
    localeMetadata {
      address(countryCode: $countryCode, languageCode: $languageCode) {
        ...AddressMetadata
      }
    }
  }
  ${ADDRESS_METADATA_FRAGMENT}
`;
